import { generateStringCache, generateTimeCache } from '@23degrees/utilities/cache.utils';
import { ChangeDetectorRef, Directive, ElementRef, HostListener, inject, Input, Renderer2 } from '@angular/core';



@Directive({
    selector: '[fallback]',
    standalone: true,
})
export class ImageFallbackDirective {
  private element = inject(ElementRef);
  private renderer = inject(Renderer2);
  cdr = inject(ChangeDetectorRef);

  @Input() fallback: string;
  @Input() retryTime: number = 10;
  @Input() retryCount: number = 0;
  @Input() cacheTime: number = 60;
  @Input() cacheReference: any;
  @Input() ignoreFallback: boolean = false;

  private originalSrc: string;
  private firstLoad: boolean = true;

  private getCache = () => {
    if (this.firstLoad) {
      const hash = <any>generateTimeCache(1);
      return `?cache=${generateStringCache(hash)}`;
    }

    if (this.cacheReference) {
      const hash = String(this.cacheReference) + (this.retryCount > 0 ? this.retryCount : '');
      return `?cache=${generateStringCache(hash)}`;
    }

    if (this.cacheTime > 0) {
      const hash = <any>generateTimeCache(this.cacheTime) + (this.retryCount > 0 ? this.retryCount : '');
      return `?cache=${generateStringCache(hash)}`;
    }

    return '';
  };

  ngAfterViewInit() {
    if (this.ignoreFallback) return;
    this.originalSrc = this.element.nativeElement.src;
    // this.renderer.setAttribute(this.element.nativeElement, 'src', this.originalSrc + this.getCache());
    this.firstLoad = false;
  }

  @HostListener('error', ['$event']) onError(event) {
    if (this.ignoreFallback) return;
    this.renderer.setAttribute(this.element.nativeElement, 'src', this.fallback);

    if (this.retryCount > 0) {
      this.retryCount--;
      setTimeout(() => {
        this.renderer.setAttribute(this.element.nativeElement, 'src', this.originalSrc + this.getCache());
        // this.safeDetectChanges();
      }, this.retryTime * 1000);
    }
  }

  public safeDetectChanges = () => {
    if (!this.cdr['destroyed']) this.cdr.detectChanges();
  };
}
